export default function Version() {
    return (
        <>
            <small>v1.5.0</small>
        </>
    )
}